import { render, staticRenderFns } from "./schoolMultipleSearch.vue?vue&type=template&id=17bb018a&"
import script from "./schoolMultipleSearch.vue?vue&type=script&lang=js&"
export * from "./schoolMultipleSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports